export const PLAYBACK_PROVIDER = Object.freeze({
  CLOUDFLARE: "cloudflare",
  MUX: "mux",
});

export function initialPlaybackProvider() {
  return PLAYBACK_PROVIDER.CLOUDFLARE;
}

export function learnerPreferenceStorageKey({ courseId, uid }) {
  const course = String(courseId || "").trim();
  const learner = String(uid || "").trim();
  return course && learner ? `cc:learner-playback-provider:v1:${learner}:${course}` : "";
}

export function readLearnerProviderPreference({ storage, courseId, uid }) {
  const key = learnerPreferenceStorageKey({ courseId, uid });
  if (!key || !storage) return PLAYBACK_PROVIDER.CLOUDFLARE;
  try {
    return storage.getItem(key) === PLAYBACK_PROVIDER.MUX
      ? PLAYBACK_PROVIDER.MUX : PLAYBACK_PROVIDER.CLOUDFLARE;
  } catch { return PLAYBACK_PROVIDER.CLOUDFLARE; }
}

export function writeLearnerProviderPreference({ storage, courseId, uid, provider }) {
  const key = learnerPreferenceStorageKey({ courseId, uid });
  const value = provider === PLAYBACK_PROVIDER.MUX
    ? PLAYBACK_PROVIDER.MUX : PLAYBACK_PROVIDER.CLOUDFLARE;
  if (!key || !storage) return value;
  try { storage.setItem(key, value); } catch {}
  return value;
}

export function clearLearnerProviderPreference({ storage, courseId, uid }) {
  const key = learnerPreferenceStorageKey({ courseId, uid });
  if (key && storage) {
    try { storage.removeItem(key); } catch {}
  }
  return PLAYBACK_PROVIDER.CLOUDFLARE;
}

export function resolveActivePlaybackProvider({ preferredProvider, muxAvailability }) {
  return preferredProvider === PLAYBACK_PROVIDER.MUX && muxAvailability === "ready"
    ? PLAYBACK_PROVIDER.MUX : PLAYBACK_PROVIDER.CLOUDFLARE;
}

export function learnerStandbyUiVisible({ previewMode, standbyAvailability }) {
  return previewMode !== true && standbyAvailability === "learner_enabled";
}

export function normalizeLearnerPreferenceForPolicy({ preferredProvider, standbyAvailability }) {
  return standbyAvailability === "learner_enabled" && preferredProvider === PLAYBACK_PROVIDER.MUX
    ? PLAYBACK_PROVIDER.MUX : PLAYBACK_PROVIDER.CLOUDFLARE;
}

export function canOfferMuxPreview({ previewMode, muxAvailability }) {
  return previewMode === true && muxAvailability === "ready";
}

export function canRequestMuxPlaybackCredential({
  previewMode, standbyAvailability, accessStatus, lessonId,
}) {
  if (!lessonId) return false;
  if (previewMode === true) return true;
  return standbyAvailability === "learner_enabled" && accessStatus === "allowed";
}

export function switchPreviewProvider({ previewMode, muxAvailability, provider }) {
  if (provider === PLAYBACK_PROVIDER.MUX) {
    return canOfferMuxPreview({ previewMode, muxAvailability })
      ? PLAYBACK_PROVIDER.MUX
      : PLAYBACK_PROVIDER.CLOUDFLARE;
  }
  return PLAYBACK_PROVIDER.CLOUDFLARE;
}

export function credentialIsUsable(credential, nowSec = Date.now() / 1000) {
  return !!credential?.playbackUrl && Number(credential?.exp || 0) > Number(nowSec) + 30;
}
